import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { BrandLogo } from '../../components/BrandLogo';

/**
 * Shared chrome for the public legal pages (/privacy, /terms). These routes
 * are mounted outside every auth guard in routes.tsx — they must render for
 * signed-out visitors (app-store reviewers included) and for signed-in users.
 */
export function LegalLayout({
  title,
  lastUpdated,
  children,
}: {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}) {
  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-2xl flex-col gap-8 px-4 py-10">
      <div className="flex flex-col items-center gap-3 text-center">
        <Link to="/" aria-label="FewerBags home">
          <BrandLogo size={56} />
        </Link>
        <h1 className="text-2xl">{title}</h1>
        <p className="text-sm text-muted">Last updated: {lastUpdated}</p>
      </div>
      <article className="flex flex-col gap-6 card p-6 text-sm leading-relaxed text-ink [&_h2]:mt-2 [&_h2]:text-lg [&_h2]:text-brand [&_p]:leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-1 [&_li]:leading-relaxed [&_a]:font-medium [&_a]:text-brand [&_a]:underline-offset-2 hover:[&_a]:underline">
        {children}
      </article>
      <p className="text-center text-sm text-muted">
        <Link to="/" className="font-medium text-brand underline-offset-2 hover:underline">
          Back to FewerBags
        </Link>
      </p>
    </main>
  );
}
